import React, { createContext, useContext } from "react";
import { userCategoriesQuery, userCategoriesStore } from "../states";

let operationsAllowed: any = {};
const UserCategoriesServiceContext = createContext(operationsAllowed);

export const UserCategoriesServiceProvider = (props: any) => {

  const getUserCategoriesActiveTabIndex = () => {
    return userCategoriesQuery.getValue().userCategoriesPage.activeTabIndex;
  }

  const setUserCategoriesActiveTabIndex = (activeTabIndex: number) => {
    userCategoriesStore.update({userCategoriesPage: {activeTabIndex: activeTabIndex}});
  }

  operationsAllowed = {
    getUserCategoriesActiveTabIndex,
    setUserCategoriesActiveTabIndex
  };

  return (
    <UserCategoriesServiceContext.Provider value={operationsAllowed}>
      {props.children}
    </UserCategoriesServiceContext.Provider>
  );
}

export const useUserCategoriesService = () => {
  return useContext(UserCategoriesServiceContext);
}
